<div fxLayout="row" fxLayoutGap="1rem" [routerLink]="routerLink" style="cursor: pointer">
    <div data-qa="messages" fxFlex="8" fxLayout="column"
         fxLayoutAlign="space-around stretch">
        <img mat-card-sm-image src="/assets/eon-pictograms/smart_market.svg">
    </div>

    <div data-qa="messages" fxFlex="60" fxLayout="column" fxLayoutAlign="space-around stretch">
        <p>
            Ihre Daten sollten monatlich aktualisiert werden. Beim Anlegen, Ändern oder Importieren
            von Erzeugern geschieht dies automatisch. Falls es jedoch keine Änderungen gibt, können Sie uns
            die Aktualität
            Ihrer Daten bestätigen, indem Sie in der Erzeugerliste auf den Button 'Datenaktualität bestätigen' klicken.
        </p>
    </div>

    <div class="notify-badge" data-qa="link" fxFlex="33" fxLayoutAlign="center center">
        <div class="badge-text">Jetzt bestätigen</div>
    </div>
</div>
